export default __webpack_public_path__ + "static/media/citiasia-logo.7edddefd.png";